var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCinedShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1729.98,
    height: 995.572,
    viewBox: "0 0 1729.98 995.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_610",
    "data-name": "Grupo 610",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, -147.25, -0.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_609",
    "data-name": "Grupo 609",
    transform: "translate(675.742 248.939) rotate(-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_590",
    "data-name": "Caminho 590",
    d: "M0,272.867,1050.165,0V808.588L0,538.225Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#391d69",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_592",
    "data-name": "Caminho 592",
    d: "M-3100.974-8219.727l-785.413-170.306-283.879,700.313,607.642-70.383",
    transform: "translate(4308 8542.992)",
    fill: "none",
    stroke: "#f49800",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinedShape);
export default __webpack_public_path__ + "static/media/cined-shape.7137d5b09c659974aeaed148f26aab00.svg";
export { ForwardRef as ReactComponent };